import subscribe from './lib/subscribe';
import initialSDK from './lib/initialSDK';
import loadWeb from './lib/loadMicroApp';
import webpack from './utils/webpack';
import register from './lib/register';
import { start, runAfterFirstMounted, setDefaultMountApp } from 'qiankun';
// import addAntCssPrefixPlugin from './utils/addAntCssPrefix';

export default {
  initial: initialSDK,
  load: loadWeb,
  subscribe: subscribe,
  webpack,
  start,
  runAfterFirstMounted,
  setDefaultMountApp,
  register,
};


export * from './typings/index';
